import React, {useEffect, useState} from 'react'
import _, {cloneDeep} from "lodash";
import {COLOR_LIST} from "../../../../common/constants/color.constant";
import {TrashIcon} from "@heroicons/react/24/solid";
import ClearButton from "../../../../common/ui/clear-button";
import RenderFields from "../../../../common/ui/render-fields";
import {
    COLOR_FIELD_LIST,
    GRADIENT_POSITION_FIELD_LIST,
    RADIAL_GRADIENT_RADIUS_FIELD_LIST,
    RECTANGLE_FIELD_LIST
} from "../../../constants/design.constant";
import SelectGradientColorDetails from "./select-gradient-color-details";
import SelectColorCodeDetails from "./select-color-code-details";
import {getColorHexCode} from "../../../../common/utils/color-util";
import {processBackgroundDetails} from "../../../utils/background-util";
import {generateLinearGradientDetail} from "../../../../common/utils/tailwind-color-util";

const colorList = _.orderBy(COLOR_LIST, 'colorKey');

const SelectColorTypeDetails = ({
                                    label,
                                    hideLabel = false,
                                    parentForm,
                                    colorAttribute,
                                    colorKeyAttribute,
                                    colorCodeKeyAttribute,
                                    settings,
                                    handleColorDetailsChanges,
                                    handleClearColorDetailsChanges,
                                }) => {
    const [showColorFields, setShowColorFields] = useState(true);
    const [colorChangedDate, setColorChangedDate] = useState(null);

    useEffect(() => {
        if (parentForm?.changedDate && parentForm?.changedDate !== colorChangedDate) {
            setColorChangedDate(parentForm?.changedDate);
            setShowColorFields(false);
            setTimeout(() => {
                setShowColorFields(true);
            }, 1);
        }
    }, [parentForm?.changedDate]);

    const handleClearColor = () => {
        if (handleClearColorDetailsChanges) {
            const attributeList = [colorKeyAttribute, colorCodeKeyAttribute, colorAttribute];
            handleClearColorDetailsChanges(attributeList, parentForm);
        }
    }

    const handleFieldChanges = (event, parentForm) => {
        const {name, value, type} = event.target

        if (colorAttribute === 'background') {
            const backgroundDetails = cloneDeep(parentForm);
            backgroundDetails[name] = value;

            processBackgroundDetails(backgroundDetails, settings, colorKeyAttribute, colorCodeKeyAttribute);

            event = {
                target: {
                    name: 'background',
                    value: backgroundDetails,
                    type: 'object'
                }
            };
        }

        handleColorDetailsChanges(event, parentForm);
    }

    const generateRandomBackgroundColor = () => {
        const linearGradientDetail = generateLinearGradientDetail(true);
        let backgroundDetails = cloneDeep(parentForm);

        backgroundDetails = {
            ...backgroundDetails,
            ...linearGradientDetail
        };

        processBackgroundDetails(backgroundDetails, settings);

        const event = {
            target: {
                name: 'background',
                value: backgroundDetails,
                type: 'object'
            }
        };

        handleColorDetailsChanges(event, parentForm);
    }

    return (
        <>

            {!hideLabel &&
                <div className={'flex justify-start items-center'}>
                    <div className="ml-2 field-label">
                        {label}
                    </div>

                    {colorAttribute === 'background' &&
                        <div className={'ml-4'}>
                            <button
                                className="button-sky-outline px-2 py-1 flex justify-center items-center"
                                onClick={generateRandomBackgroundColor}>
                                Random Color
                            </button>
                        </div>
                    }
                </div>
            }

            {showColorFields &&

                <>
                    {parentForm &&
                        <div className="flex flex-wrap justify-start">
                            <RenderFields
                                parentForm={parentForm}
                                handleDetailChanges={(event) => {
                                    handleFieldChanges(event, parentForm);
                                }}
                                fieldList={_.groupBy(COLOR_FIELD_LIST, 'group')['color']}
                                enableEdit={true}
                                fieldClassName={'w-1/2'}/>
                        </div>
                    }

                    {parentForm?.colorType === 'solid' &&
                        <>
                            <div className="ml-2 field-label">
                                Solid Color & Shade
                            </div>

                            <SelectColorCodeDetails
                                parentForm={parentForm}
                                colorAttribute={colorAttribute}
                                colorKeyAttribute={colorKeyAttribute}
                                colorCodeKeyAttribute={colorCodeKeyAttribute}
                                handleColorDetailsChanges={handleFieldChanges}
                                handleClearColorDetailsChanges={handleClearColorDetailsChanges}/>
                        </>
                    }

                    {(parentForm?.colorType === 'linear' || parentForm?.colorType === 'radial') &&
                        <div className="flex flex-wrap justify-start">
                            <RenderFields
                                parentForm={parentForm}
                                handleDetailChanges={(event) => {
                                    handleFieldChanges(event, parentForm);
                                }}
                                fieldList={_.groupBy(GRADIENT_POSITION_FIELD_LIST, 'group')['position']}
                                enableEdit={true}
                                fieldClassName={'w-1/2'}/>
                        </div>
                    }

                    {parentForm?.colorType === 'radial' &&
                        <div className="flex flex-wrap justify-start">
                            <RenderFields
                                parentForm={parentForm}
                                handleDetailChanges={(event) => {
                                    handleFieldChanges(event, parentForm);
                                }}
                                fieldList={_.groupBy(RADIAL_GRADIENT_RADIUS_FIELD_LIST, 'group')['radius']}
                                enableEdit={true}
                                fieldClassName={'w-1/2'}/>
                        </div>
                    }

                    {parentForm?.colorType === 'linear' &&
                        <SelectGradientColorDetails
                            label={'Linear Gradient Color & Shade'}
                            parentForm={parentForm}
                            colorType={parentForm['colorType']}
                            colorAttribute={colorAttribute}
                            colorKeyAttribute={colorKeyAttribute}
                            colorCodeKeyAttribute={colorCodeKeyAttribute}
                            settings={settings}
                            handleColorDetailsChanges={handleColorDetailsChanges}
                            handleClearColorDetailsChanges={handleClearColor}/>
                    }

                    {parentForm?.colorType === 'radial' &&
                        <SelectGradientColorDetails
                            label={'Radial Gradient Color & Shade'}
                            parentForm={parentForm}
                            colorType={parentForm['colorType']}
                            colorAttribute={colorAttribute}
                            colorKeyAttribute={colorKeyAttribute}
                            colorCodeKeyAttribute={colorCodeKeyAttribute}
                            settings={settings}
                            handleColorDetailsChanges={handleColorDetailsChanges}
                            handleClearColorDetailsChanges={handleClearColor}/>
                    }
                </>
            }

        </>
    )
}

export default SelectColorTypeDetails
